// removed by extract-text-webpack-plugin
module.exports = {"rewardSuccessCard":"rewardSuccessCard___3Xqqu","scaleIn":"scaleIn___1Tk8G","iconContainer":"iconContainer___johI0","checkIcon":"checkIcon___3jK_B","checkPulse":"checkPulse___3aJy3","giftIcon":"giftIcon___2wLV3","giftBounce":"giftBounce___34uoF","title":"title___1Z7Fe","amountBox":"amountBox___Tl9-p","amount":"amount___3wa3Y","amountLabel":"amountLabel___3ANbE","infoSection":"infoSection___3x9bJ","emailIcon":"emailIcon___2nLpt","infoText":"infoText___52sw5","thankYouBox":"thankYouBox___2dc7K","thankYouText":"thankYouText___Knynu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/RewardSuccessMessage.module.less
// module id = 3839
// module chunks = 33